import { createContext } from 'react';

export type JobPositionIdContextType = string | undefined;

export const JobPositionIdContext = createContext<JobPositionIdContextType>(undefined);
